import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { StaffList } from "../../api/Staff";
import { StudentSearch } from "../../api/Student";
import { batchList } from "../../api/Batch";
import { addAssignmentApi } from "../../api/AssignmentService";
import { useNavigate } from "react-router-dom";
import AcademicHeader from "../Academic/AcademicHeader";
import { subjectList } from "../../api/Subjects";

export default function AssignmentAdd() {
  const [loading, setLoading] = useState(false);

  const [targetType, setTargetType] = useState("");

  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);

  const [batches, setBatches] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);

  const [staffs, setStaffs] = useState([]);
  const [selectedStaffs, setSelectedStaffs] = useState([]);

  const [subjects, setSubjects] = useState([]);
  const [subjectId, setSubjectId] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    getSubjects();
  }, []);

  const getSubjects = async () => {
    try {
      const response = await subjectList();

      if (response?.data?.status) {
        setSubjects(response?.data?.data?.data || response?.data?.data || []);
      }
    } catch (error) {
      console.log("SUBJECT ERROR:", error);
    }
  };

  useEffect(() => {
    if (search.length > 1 && targetType === "student") {
      StudentSearch(`search=${search}`)
        .then((res) => {
          setStudents(res?.data?.data || []);
        })
        .catch((error) => {
          console.log("STUDENT ERROR:", error);
        });
    } else {
      setStudents([]);
    }
  }, [search, targetType]);

  useEffect(() => {
    if (targetType === "batch") {
      getBatches();
    } else {
      setBatches([]);
    }
  }, [targetType]);

  const getBatches = async () => {
    try {
      const res = await batchList();

      if (res?.data?.status) {
        setBatches(res?.data?.data?.data || res?.data?.data || []);
      }
    } catch (error) {
      console.log("BATCH ERROR:", error);
    }
  };

  useEffect(() => {
    if (targetType === "staff") {
      getStaffs();
    } else {
      setStaffs([]);
    }
  }, [targetType]);

  const getStaffs = async () => {
    setLoading(true);

    try {
      const response = await StaffList();

      if (response?.data?.status) {
        setStaffs(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTargetTypeChange = (value) => {
    setTargetType(value);

    setSearch("");
    setStudents([]);

    setSelectedStudents([]);
    setSelectedBatches([]);
    setSelectedStaffs([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let targetIds = [];

    if (targetType === "student") {
      targetIds = selectedStudents.map((student) => student.id);
    }

    if (targetType === "batch") {
      targetIds = selectedBatches.map((batch) => batch.id);
    }

    if (targetType === "staff") {
      targetIds = selectedStaffs.map((staff) => staff.id);
    }

    if (targetType !== "all" && targetIds.length === 0) {
      SweetAlertShow(
        "warning",
        "Warning",
        "Please select at least one target.",
      );

      return;
    }

    if (!subjectId) {
      SweetAlertShow("warning", "Warning", "Please select subject.");

      return;
    }

    const formData = new FormData();

    formData.append("title", e.target.title.value);
    formData.append("type", e.target.type.value);
    formData.append("subject_id", subjectId);
    formData.append("due_date", e.target.due_date.value);
    formData.append("allow_submission", e.target.allow_submission.value);
    formData.append("description", e.target.description.value);
    formData.append("target_type", targetType);

    targetIds.forEach((id, index) => {
      formData.append(`target_id[${index}]`, id);
    });

    if (e.target.file.files[0]) {
      formData.append("file", e.target.file.files[0]);
    }

    try {
      setLoading(true);

      const res = await addAssignmentApi(formData);

      if (res?.data?.status) {
        SweetAlertShow("success", "Success", res?.data?.message);

        e.target.reset();

        setSubjectId("");
        setTargetType("");

        setSearch("");
        setStudents([]);
        setSelectedStudents([]);

        setBatches([]);
        setSelectedBatches([]);

        setStaffs([]);
        setSelectedStaffs([]);

        navigate(-1);
      } else {
        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // Small helper for initials-avatar chips
  const initials = (name = "") =>
    name
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((n) => n[0]?.toUpperCase())
      .join("");

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row mt-4">
                  <AcademicHeader />

                  <div className="col-12">
                    <div className="card shadow-sm border-0">
                      <div className="card-body p-4 p-md-5">
                        <form onSubmit={handleSubmit}>
                          {/* ---- Page Header ---- */}
                          <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                            <div className="d-flex align-items-center gap-2">
                              <span
                                className="d-inline-flex align-items-center justify-content-center rounded-circle bg-label-primary"
                                style={{ width: 40, height: 40 }}
                              >
                                <i className="ri-file-edit-line ri-lg text-primary"></i>
                              </span>
                              <div>
                                <h4 className="text-primary mb-0">
                                  Assignment Add
                                </h4>
                                <small className="text-muted">
                                  Create and assign a new task, homework, or
                                  project
                                </small>
                              </div>
                            </div>
                          </div>

                          {/* ---- Basic Details ---- */}
                          <h6 className="text-uppercase text-muted small fw-bold mb-3 d-flex align-items-center gap-2">
                            <i className="ri-information-line"></i> Basic
                            Details
                          </h6>

                          <div className="row g-3 mb-4">
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-capitalize"
                                  name="title"
                                  placeholder="Enter Assignment Title"
                                  required
                                />
                                <label>Assignment Title</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="type"
                                  defaultValue=""
                                  required
                                >
                                  <option value="" disabled>
                                    Select Type
                                  </option>
                                  <option value="homework">Homework</option>
                                  <option value="task">Task</option>
                                  <option value="project">Project</option>
                                  <option value="activity">Activity</option>
                                </select>
                                <label>Assignment Type</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="subject_id"
                                  value={subjectId}
                                  onChange={(e) => setSubjectId(e.target.value)}
                                  required
                                >
                                  <option value="">Select Subject</option>
                                  {subjects.map((subject) => (
                                    <option key={subject.id} value={subject.id}>
                                      {subject.name}
                                    </option>
                                  ))}
                                </select>
                                <label>Subject</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="date"
                                  className="form-control"
                                  name="due_date"
                                  required
                                />
                                <label>Due Date</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="allow_submission"
                                  defaultValue=""
                                  required
                                >
                                  <option value="" disabled>
                                    Select Option
                                  </option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                                <label>Allow Submission</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="target_type"
                                  className="form-select"
                                  value={targetType}
                                  onChange={(e) =>
                                    handleTargetTypeChange(e.target.value)
                                  }
                                  required
                                >
                                  <option value="">Select Target Type</option>
                                  {/* <option value="all">All Students</option> */}
                                  <option value="student">Student</option>
                                  <option value="batch">Batch</option>
                                  <option value="staff">Staff</option>
                                </select>
                                <label>Target Type</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="file"
                                  className="form-control"
                                  name="file"
                                />
                                <label>Upload File</label>
                              </div>
                            </div>

                            <div className="col-12">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  className="form-control input-uppercase"
                                  name="description"
                                  placeholder="Enter Description"
                                  style={{ height: "100px" }}
                                ></textarea>
                                <label>Description</label>
                              </div>
                            </div>
                          </div>

                          {/* ---- Target Selection: Student ---- */}
                          {targetType === "student" && (
                            <div className="mb-4">
                              <h6 className="text-uppercase text-muted small fw-bold mb-3 d-flex align-items-center gap-2">
                                <i className="ri-user-search-line"></i> Select
                                Students
                              </h6>

                              <div className="row g-3">
                                <div className="col-sm-6">
                                  <div className="form-floating form-floating-outline mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search Student"
                                      value={search}
                                      onChange={(e) =>
                                        setSearch(e.target.value)
                                      }
                                    />
                                    <label>
                                      <i className="ri-search-line me-1"></i>
                                      Search Student
                                    </label>
                                  </div>

                                  <div
                                    className="border rounded-3 p-2 bg-lighter"
                                    style={{
                                      maxHeight: "260px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {students.length > 0 ? (
                                      students.map((item) => (
                                        <div
                                          key={item.id}
                                          className="d-flex align-items-center gap-2 p-2 rounded-2 mb-1 bg-white border list-hover-item"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (
                                              !selectedStudents.find(
                                                (s) => s.id === item.id,
                                              )
                                            ) {
                                              setSelectedStudents([
                                                ...selectedStudents,
                                                item,
                                              ]);
                                            }
                                            setSearch("");
                                            setStudents([]);
                                          }}
                                        >
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-label-primary text-primary fw-semibold flex-shrink-0"
                                            style={{
                                              width: 34,
                                              height: 34,
                                              fontSize: 12,
                                            }}
                                          >
                                            {initials(item.name)}
                                          </span>
                                          <div className="flex-grow-1">
                                            <div className="fw-semibold small">
                                              {item.name}
                                            </div>
                                            <small className="text-muted">
                                              {item.registration_no}
                                            </small>
                                          </div>
                                          <i className="ri-add-circle-line text-primary"></i>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-muted text-center py-4 small">
                                        <i className="ri-search-eye-line d-block fs-4 mb-1"></i>
                                        Type at least 2 characters to search
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-sm-6">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <span className="fw-semibold small text-muted">
                                      Selected Students
                                    </span>
                                    {selectedStudents.length > 0 && (
                                      <span className="badge bg-label-primary rounded-pill">
                                        {selectedStudents.length}
                                      </span>
                                    )}
                                  </div>

                                  <div
                                    className="border rounded-3 p-2"
                                    style={{
                                      minHeight: "260px",
                                      maxHeight: "260px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {selectedStudents.length > 0 ? (
                                      <div className="d-flex flex-column gap-2">
                                        {selectedStudents.map((item) => (
                                          <div
                                            key={item.id}
                                            className="d-flex align-items-center gap-2 border rounded-2 p-2 bg-lighter"
                                          >
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center rounded-circle bg-label-success text-success fw-semibold flex-shrink-0"
                                              style={{
                                                width: 34,
                                                height: 34,
                                                fontSize: 12,
                                              }}
                                            >
                                              {initials(item.name)}
                                            </span>
                                            <div className="flex-grow-1">
                                              <div className="fw-semibold small">
                                                {item.name}
                                              </div>
                                              <small className="text-muted">
                                                {item.registration_no}
                                              </small>
                                            </div>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-icon btn-outline-danger rounded-circle"
                                              onClick={() =>
                                                setSelectedStudents(
                                                  selectedStudents.filter(
                                                    (s) => s.id !== item.id,
                                                  ),
                                                )
                                              }
                                            >
                                              <i className="ri-close-line"></i>
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className="text-muted text-center py-4 small">
                                        <i className="ri-user-line d-block fs-4 mb-1"></i>
                                        No student selected yet
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* ---- Target Selection: Batch ---- */}
                          {targetType === "batch" && (
                            <div className="mb-4">
                              <h6 className="text-uppercase text-muted small fw-bold mb-3 d-flex align-items-center gap-2">
                                <i className="ri-stack-line"></i> Select Batches
                              </h6>

                              <div className="row g-3">
                                <div className="col-sm-6">
                                  <div
                                    className="border rounded-3 p-2 bg-lighter"
                                    style={{
                                      maxHeight: "260px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {batches.length > 0 ? (
                                      batches.map((item) => {
                                        const selected = selectedBatches.some(
                                          (b) => b.id === item.id,
                                        );

                                        return (
                                          <div
                                            key={item.id}
                                            className={`d-flex align-items-center gap-2 p-2 rounded-2 mb-1 border list-hover-item ${
                                              selected
                                                ? "bg-label-primary border-primary"
                                                : "bg-white"
                                            }`}
                                            style={{
                                              cursor: selected
                                                ? "default"
                                                : "pointer",
                                            }}
                                            onClick={() => {
                                              if (!selected) {
                                                setSelectedBatches([
                                                  ...selectedBatches,
                                                  item,
                                                ]);
                                              }
                                            }}
                                          >
                                            <i className="ri-stack-line text-primary"></i>
                                            <div className="flex-grow-1 fw-semibold small">
                                              {item.title}
                                            </div>
                                            {selected ? (
                                              <i className="ri-checkbox-circle-fill text-success"></i>
                                            ) : (
                                              <i className="ri-add-circle-line text-primary"></i>
                                            )}
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <div className="text-muted text-center py-4 small">
                                        <i className="ri-inbox-line d-block fs-4 mb-1"></i>
                                        No batch found
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-sm-6">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <span className="fw-semibold small text-muted">
                                      Selected Batches
                                    </span>
                                    {selectedBatches.length > 0 && (
                                      <span className="badge bg-label-primary rounded-pill">
                                        {selectedBatches.length}
                                      </span>
                                    )}
                                  </div>

                                  <div
                                    className="border rounded-3 p-2"
                                    style={{
                                      minHeight: "260px",
                                      maxHeight: "260px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {selectedBatches.length > 0 ? (
                                      <div className="d-flex flex-column gap-2">
                                        {selectedBatches.map((item) => (
                                          <div
                                            key={item.id}
                                            className="d-flex align-items-center gap-2 border rounded-2 p-2 bg-lighter"
                                          >
                                            <i className="ri-stack-line text-success"></i>
                                            <span className="fw-semibold small flex-grow-1">
                                              {item.title}
                                            </span>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-icon btn-outline-danger rounded-circle"
                                              onClick={() =>
                                                setSelectedBatches(
                                                  selectedBatches.filter(
                                                    (b) => b.id !== item.id,
                                                  ),
                                                )
                                              }
                                            >
                                              <i className="ri-close-line"></i>
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className="text-muted text-center py-4 small">
                                        <i className="ri-stack-line d-block fs-4 mb-1"></i>
                                        No batch selected yet
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* ---- Target Selection: Staff ---- */}
                          {targetType === "staff" && (
                            <div className="mb-4">
                              <h6 className="text-uppercase text-muted small fw-bold mb-3 d-flex align-items-center gap-2">
                                <i className="ri-team-line"></i> Select Staff
                              </h6>

                              <div className="row g-3">
                                <div className="col-sm-6">
                                  <div
                                    className="border rounded-3 p-2 bg-lighter"
                                    style={{
                                      maxHeight: "260px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {staffs.length > 0 ? (
                                      staffs.map((item) => {
                                        const selected = selectedStaffs.some(
                                          (s) => s.id === item.id,
                                        );

                                        return (
                                          <div
                                            key={item.id}
                                            className={`d-flex align-items-center gap-2 p-2 rounded-2 mb-1 border list-hover-item ${
                                              selected
                                                ? "bg-label-primary border-primary"
                                                : "bg-white"
                                            }`}
                                            style={{
                                              cursor: selected
                                                ? "default"
                                                : "pointer",
                                            }}
                                            onClick={() => {
                                              if (!selected) {
                                                setSelectedStaffs([
                                                  ...selectedStaffs,
                                                  item,
                                                ]);
                                              }
                                            }}
                                          >
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center rounded-circle bg-label-info text-info fw-semibold flex-shrink-0"
                                              style={{
                                                width: 34,
                                                height: 34,
                                                fontSize: 12,
                                              }}
                                            >
                                              {initials(item.name)}
                                            </span>
                                            <div className="flex-grow-1">
                                              <div className="fw-semibold small">
                                                {item.name}
                                              </div>
                                              {item.mobile && (
                                                <small className="text-muted">
                                                  {item.mobile}
                                                </small>
                                              )}
                                            </div>
                                            {selected ? (
                                              <i className="ri-checkbox-circle-fill text-success"></i>
                                            ) : (
                                              <i className="ri-add-circle-line text-primary"></i>
                                            )}
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <div className="text-muted text-center py-4 small">
                                        <i className="ri-team-line d-block fs-4 mb-1"></i>
                                        No staff found
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-sm-6">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <span className="fw-semibold small text-muted">
                                      Selected Staff
                                    </span>
                                    {selectedStaffs.length > 0 && (
                                      <span className="badge bg-label-primary rounded-pill">
                                        {selectedStaffs.length}
                                      </span>
                                    )}
                                  </div>

                                  <div
                                    className="border rounded-3 p-2"
                                    style={{
                                      minHeight: "260px",
                                      maxHeight: "260px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {selectedStaffs.length > 0 ? (
                                      <div className="d-flex flex-column gap-2">
                                        {selectedStaffs.map((item) => (
                                          <div
                                            key={item.id}
                                            className="d-flex align-items-center gap-2 border rounded-2 p-2 bg-lighter"
                                          >
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center rounded-circle bg-label-success text-success fw-semibold flex-shrink-0"
                                              style={{
                                                width: 34,
                                                height: 34,
                                                fontSize: 12,
                                              }}
                                            >
                                              {initials(item.name)}
                                            </span>
                                            <div className="flex-grow-1">
                                              <div className="fw-semibold small">
                                                {item.name}
                                              </div>
                                              {item.mobile && (
                                                <small className="text-muted">
                                                  {item.mobile}
                                                </small>
                                              )}
                                            </div>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-icon btn-outline-danger rounded-circle"
                                              onClick={() =>
                                                setSelectedStaffs(
                                                  selectedStaffs.filter(
                                                    (s) => s.id !== item.id,
                                                  ),
                                                )
                                              }
                                            >
                                              <i className="ri-close-line"></i>
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className="text-muted text-center py-4 small">
                                        <i className="ri-team-line d-block fs-4 mb-1"></i>
                                        No staff selected yet
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* ---- Actions ---- */}
                          <div className="d-flex justify-content-end gap-2 pt-3 border-top">
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => navigate(-1)}
                            >
                              <i className="ri-close-line me-1"></i>
                              Cancel
                            </button>

                            <button type="submit" className="btn btn-primary">
                              <i className="ri-send-plane-line me-1"></i>
                              Submit Assignment
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .list-hover-item:hover {
          box-shadow: 0 1px 6px rgba(0,0,0,0.08);
          transform: translateY(-1px);
          transition: all .15s ease;
        }
        .bg-lighter {
          background-color: rgba(0,0,0,0.015);
        }
      `}</style>
    </>
  );
}
